import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e1bedd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Solicitudes de Cuenta")
], -1))
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "flex justify-content-end" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle mr-3",
    style: {"font-size":"2rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "¿Está seguro de aprobar las solicitudes seleccionadas?")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Toolbar, { class: "mb-4" }, {
        start: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Aprobar",
            icon: "pi pi-check",
            class: "p-button-danger btn-melon",
            onClick: _ctx.confirmApproveSelected,
            disabled: !_ctx.selectedSolicitudes || !_ctx.selectedSolicitudes.length
          }, null, 8, ["onClick", "disabled"])
        ]),
        end: _withCtx(() => []),
        _: 1
      }),
      _createVNode(_component_DataTable, {
        value: _ctx.store.getters.allSolicitudes,
        paginator: true,
        rows: 10,
        showGridlines: "",
        dataKey: "solicitudId",
        rowHover: true,
        selection: _ctx.selectedSolicitudes,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSolicitudes) = $event)),
        filters: _ctx.filters1,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters1) = $event)),
        loading: _ctx.loading,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [10, 25, 50],
        currentPageReportTemplate: "Mostrando {first} a {last} de {totalRecords} registros",
        globalFilterFields: [
          'rutProveedor',
          'contactoEmail',
          'contactoNombre',
          'contactoTelefono',
        ],
        responsiveLayout: "scroll"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters1['global'].value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters1['global'].value) = $event)),
                placeholder: "Buscar"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(" No existen solicitudes. ")
        ]),
        loading: _withCtx(() => [
          _createTextVNode(" Cargando sus solicitudes. Por favor espere. ")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            style: {"width":"3rem"},
            exportable: false
          }),
          _createVNode(_component_Column, {
            field: "rutProveedor",
            header: "Rut Proveedor",
            sortable: "",
            style: {"min-width":"9rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.rutProveedor), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: "Search by name"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "contactoEmail",
            header: "Email",
            sortable: "",
            filterMatchMode: "contains",
            style: {"min-width":"14rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.contactoEmail), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: "Search by country"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "contactoNombreCompleto",
            header: "Nombre Contacto",
            sortable: "",
            filterMatchMode: "contains",
            style: {"min-width":"14rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.contactoNombreCompleto), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: "Search by country"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "contactoTelefono",
            header: "Teléfono Contacto",
            sortable: "",
            filterMatchMode: "contains",
            style: {"min-width":"14rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.contactoTelefono), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: "Search by country"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "activado",
            header: "Estado",
            style: {"min-width":"14rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["image-text", 'customer-badge status-' + data.activado])
              }, _toDisplayString(data.activado ? "Usuario Aprobado" : "Pendiente"), 3)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                class: "p-column-filter",
                placeholder: "Search by country"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "fechaSolicitud",
            header: "F. Solicitud",
            sortable: "",
            dataType: "date",
            style: {"min-width":"8rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaSolicitud)), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_Calendar, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                dateFormat: "mm/dd/yy",
                placeholder: "mm/dd/yyyy"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            style: {"min-width":"8rem"}
          }, {
            body: _withCtx((slotProps) => [
              (!slotProps.data.activado)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-pencil",
                    class: "p-button-rounded p-button-success mr-2",
                    onClick: ($event: any) => (_ctx.editSolicitud(slotProps.data))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "selection", "filters", "loading"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.approveSolicitudesDialog,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.approveSolicitudesDialog) = $event)),
        style: { width: '450px' },
        header: "Confirm",
        modal: true
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "No",
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.approveSolicitudesDialog = false))
          }),
          _createVNode(_component_Button, {
            label: "Si",
            icon: "pi pi-check",
            class: "p-button-text",
            onClick: _ctx.approveSelectedSolicitudes
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}